export default __webpack_public_path__ + "static/php-b2a8c9ca90b497f77fc880237a6070ee.png";